var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "villa-preview", class: this.lang }, [
    _c(
      "a",
      {
        staticClass: "image",
        attrs: { href: "/" + this.lang + "/villas/" + _vm.villa.url },
      },
      [
        _c("div", { staticClass: "img-loader" }),
        _vm._v(" "),
        !_vm.lazyImages
          ? _c("img", {
              attrs: { src: _vm.villa.photos[0].high, alt: _vm.villa.title },
            })
          : _c("bg-image", {
              attrs: {
                src: _vm.villa.photos[0].high,
                placeholder: _vm.villa.photos[0].low,
              },
            }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "details" }, [
      _c("p", { staticClass: "carousel-position" }, [
        _vm._v(_vm._s(_vm.position + 1) + "/" + _vm._s(_vm.length)),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "title",
          attrs: { href: "/" + this.lang + "/villas/" + _vm.villa.url },
        },
        [_vm._v(_vm._s(_vm.villa.title))]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "descr mb-sm-5 mb-3" }, [
        _vm._v(_vm._s(_vm.villa.descr)),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "specs mb-sm-5 mb-3" }, [
        _c("li", { staticClass: "spec" }, [
          _c("img", {
            attrs: {
              src: "/site/idealesresort/dist/images/bed.svg",
              alt: "bed",
            },
          }),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.villa.bedrooms))]),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "spec" }, [
          _c("img", {
            attrs: {
              src: "/site/idealesresort/dist/images/bath.svg",
              alt: "bath",
            },
          }),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.villa.bathrooms))]),
        ]),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "info-buttons" }, [
        _c("li", [
          _c(
            "a",
            {
              staticClass: "btn-primary",
              attrs: { href: "/" + this.lang + "/villas/" + _vm.villa.url },
            },
            [_vm._v(_vm._s(_vm.trans.photos[this.lang]))]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              staticClass: "btn-primary",
              attrs: {
                href:
                  "/" +
                  this.lang +
                  "/villas/" +
                  _vm.villa.url +
                  "?section=pricing",
              },
            },
            [_vm._v(_vm._s(_vm.trans.pricing[this.lang]))]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              staticClass: "btn-primary",
              attrs: {
                href:
                  "/" +
                  this.lang +
                  "/villas/" +
                  _vm.villa.url +
                  "?section=features",
              },
            },
            [_vm._v(_vm._s(_vm.trans.features[this.lang]))]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              staticClass: "btn-primary",
              attrs: {
                href:
                  "/" +
                  this.lang +
                  "/villas/" +
                  _vm.villa.url +
                  "?section=info",
              },
            },
            [_vm._v(_vm._s(_vm.trans.info[this.lang]))]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }